import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    viewBox="0 0 33 33"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M14.94 16.53c0 .74-.6 1.34-1.34 1.34h-1.34v4.02a1.34 1.34 0 1 1-2.68 0v-4.02H8.24a1.34 1.34 0 0 1 0-2.68h5.36c.74 0 1.34.6 1.34 1.34Zm9.38-6.7h-9.38a1.34 1.34 0 1 0 0 2.68h3.35v9.38a1.34 1.34 0 1 0 2.68 0v-9.38h3.35a1.34 1.34 0 0 0 0-2.68Zm8.04-2.68v18.77c0 3.7-3 6.7-6.7 6.7H6.89c-3.7 0-6.7-3-6.7-6.7V7.15c0-3.7 3-6.7 6.7-6.7h18.77c3.7 0 6.7 3 6.7 6.7Zm-2.68 0c0-2.22-1.8-4.02-4.02-4.02H6.89a4.02 4.02 0 0 0-4.02 4.02v18.77c0 2.22 1.8 4.02 4.02 4.02h18.77c2.22 0 4.02-1.8 4.02-4.02V7.15Z"
    />
  </Svg>
);
export default SvgComponent;
